import DirectDebitPay from './direct-debit-pay';

export default DirectDebitPay;
